import React, { useState, useEffect } from "react";
import { Menu, Button } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { MenuOutlined, CloseOutlined, LogoutOutlined } from "@ant-design/icons";
import AccountIcon from "../../icons/account.svg";
import BookingIcon from "../../icons/booking.svg";
import ExploreIcon from "../../icons/explore.svg";
import FavoritesIcon from "../../icons/favorites.svg";
import { logout } from "../../store/features/user";
import { removeAuthCookies } from "../../cookies";
import "./menu.css";

const SideMenu = () => {
  const [collapsed, setCollapsed] = useState(window.innerWidth <= 768);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSignOut = () => {
    // Clear auth cookies first so any in-flight protected request
    // can't reuse them, then reset Redux state, then route to /signin.
    removeAuthCookies();
    dispatch(logout());
    navigate("/signin", { replace: true });
  };

  // Check if screen is mobile size
  useEffect(() => {
    const checkIsMobile = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      // Auto-collapse on mobile
      if (mobile) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);

    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  // Update page-container class based on menu state
  useEffect(() => {
    const pageContainer = document.querySelector(".page-container");
    if (pageContainer) {
      if (collapsed) {
        pageContainer.classList.remove("menu-expanded");
      } else {
        pageContainer.classList.add("menu-expanded");
      }
    }
  }, [collapsed]);

  const toggleMenu = () => {
    setCollapsed(!collapsed);
  };

  return (
    <>
      {/* Hamburger Menu Button for Mobile */}
      {isMobile && (
        <Button
          type="text"
          icon={collapsed ? <MenuOutlined /> : <CloseOutlined />}
          onClick={toggleMenu}
          className={`hamburger-menu ${collapsed ? "collapsed" : "expanded"}`}
          style={{
            position: collapsed ? "fixed" : "absolute",
            top: "16px",
            left: collapsed ? "16px" : "auto",
            right: collapsed ? "auto" : "16px",
            zIndex: 1001,
            backgroundColor: "transparent",
            border: "1px solid transparent",
            borderRadius: "8px",
            width: "40px",
            height: "40px",
          }}
        />
      )}

      {/* Side Menu */}
      <div
        className={`side-menu ${collapsed ? "collapsed" : ""} ${
          isMobile ? "mobile" : ""
        }`}
        onClick={(e) => {
          // Close menu when clicking overlay on mobile
          if (isMobile && !collapsed && e.target === e.currentTarget) {
            setCollapsed(true);
          }
        }}
      >
        <div className="side-menu-inner">
          <Menu
            mode="inline"
            style={{
              height: "100%",
              width: collapsed ? (isMobile ? "240px" : "80px") : "240px",
            }}
            className="side-menu"
            inlineCollapsed={collapsed && !isMobile}
          >
            <div className="branding">
              <img
                src={process.env.PUBLIC_URL + "/logo.png"}
                alt="Talk2Coach"
                className="branding-logo"
              />
              {!collapsed && <h1 className="branding-title">Talk2Coach</h1>}
            </div>
            <Menu.Item
              key="account"
              icon={<img src={AccountIcon} alt="Account" />}
              style={{ margin: "5% 0" }}
            >
              <Link to="/account">{!collapsed && "Account"}</Link>
            </Menu.Item>
            <Menu.Item
              key="explore"
              icon={<img src={ExploreIcon} alt="Explore" />}
              style={{ margin: "5% 0" }}
            >
              <Link to="/explore">{!collapsed && "Explore"}</Link>
            </Menu.Item>
            <Menu.Item
              key="bookings"
              icon={<img src={BookingIcon} alt="Bookings" />}
              style={{ margin: "5% 0" }}
            >
              <Link to="/bookings">{!collapsed && "Bookings"}</Link>
            </Menu.Item>
            {/* <Menu.Item
              key="messages"
              icon={<img src={MessagesIcon} alt="Messages" />}
              style={{ margin: "5% 0" }}
            >
              <Link to="/messages">{!collapsed && "Messages"}</Link>
            </Menu.Item> */}
            <Menu.Item
              key="favorites"
              icon={<img src={FavoritesIcon} alt="Favorites" />}
              style={{ margin: "5% 0" }}
            >
              <Link to="/favorites">{!collapsed && "Favorites"}</Link>
            </Menu.Item>
            <Menu.Item
              key="wallet"
              icon={
                <span className="material-symbols-outlined">
                  account_balance_wallet
                </span>
              }
              style={{ margin: "5% 0" }}
            >
              <Link to="/wallet">{!collapsed && "Wallet"}</Link>
            </Menu.Item>
            {/* Pinned to the bottom of the side menu via `marginTop: auto`
              on the flex `.side-menu-inner` wrapper declared above. */}
            {/* The sign-out position is driven entirely by the
                `.menu-signout { margin-top: auto !important; }` rule
                in menu.css, so no inline `margin` is set here. */}
            <Menu.Item
              key="signout"
              icon={<LogoutOutlined />}
              onClick={handleSignOut}
              className="menu-signout"
              style={{ margin: "5% 0" }}
            >
              {(!collapsed || isMobile) && "Sign Out"}
            </Menu.Item>
          </Menu>
        </div>
      </div>
    </>
  );
};

export default SideMenu;
